import type { WidgetSettings } from "./widgetContext";

import { DEFAULT_LOCALE } from "./i18n";

export const WIDGET_TAG_NAME = "b2b-widget";

export const WIDGET_MODES = ["popup", "embed"] as const;

export type WidgetMode = (typeof WIDGET_MODES)[number];

export const WIDGET_API_KEYS = ["onLoad", "onDrop", "onCalc", "onCart"] as const;

export const DEFAULT_WIDGET_SETTINGS: Omit<WidgetSettings, "domain"> = {
    locale: DEFAULT_LOCALE,
    mode: "popup",
    root_element: "B2BWidget",
};
